import { render, staticRenderFns } from "./examesmesmopaciente.vue?vue&type=template&id=16ef5e47&"
import script from "./examesmesmopaciente.vue?vue&type=script&lang=js&"
export * from "./examesmesmopaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports